import { useMsal } from '@azure/msal-react';

export function useAccount() {
  const { accounts } = useMsal();
  return accounts[0] ?? null;
}
